import ApiService from "./ApiService";

export default {
  findAll() {
    return new Promise((resolve, reject) => {
      ApiService.request("GET", "notifications", {  limit: 1000 })
        .then((response) => {
          resolve(response.data);
        })
        .catch(() => {
          reject(new Error());
        });
    });
  },
  readNotifications() {
    return new Promise((resolve, reject) => {
      ApiService.request("POST", "notifications")
        .then((response) => {
          resolve(response.data);
        })
        .catch(() => {
          reject(new Error());
        });
    });
  },
  updateNotifyOnEmail() {
    return new Promise((resolve, reject) => {
      ApiService.request("PUT", "notify-on-email")
        .then((response) => {
          resolve(response.data);
        })
        .catch(() => {
          reject(new Error());
        });
    });
  }
};
